import { MQ } from '@/lib/breakpoints';
import { useMediaQuery } from './useMediaQuery';

/**
 * Hook to detect true mobile (phone) layout — sidebar in drawer, mobile header.
 *
 * Returns true when viewport is <= 767px wide (BREAKPOINTS.compactMax).
 * Use for sidebar-drawer gating and mobile-header rendering.
 *
 * ≥768px is the desktop tier — there is no intermediate compact/tablet tier
 * (PDR 008 D3, amended 2026-06-12: strict two-tier 767/768 model).
 *
 * Use this for behavioral changes (conditional rendering, logic).
 * For styling, prefer CSS @media (max-width: 767px) / (min-width: 768px)
 * queries directly.
 *
 * Usage:
 *   const isCompact = useIsCompactLayout();
 *   if (isCompact) {
 *     // Show mobile-specific UI
 *   }
 */
export const useIsCompactLayout = (): boolean => useMediaQuery(MQ.compact);
